// import hero_bg from 'assets/images/others/new_banner.jpg'
import hero_bg from 'assets/images/others/cover2.png'

const Intro = () => {
    return (
        <section id="intro">
            <img src={hero_bg} alt="" />
        </section>
    )
}

export default Intro
